import { TENANT_DASHBOARD_FEATURE_KEY } from './tenantStatsigGateConstants.js'

/**
 * Display metadata for feature keys that may be enabled at org level but omitted from `VITE_FEATURES_V2`.
 * @type {Record<string, { groupName: string, icon: string, title: string, description: string, required?: boolean }>}
 */
export const FEATURE_CATALOG_LEAF_METADATA = {
  [TENANT_DASHBOARD_FEATURE_KEY]: {
    groupName: 'App Config',
    icon: 'IconDeviceDesktopCog',
    title: 'Tenant onboarding dashboard',
    description:
      'Manage tenant onboarding, organizations, and feature configuration across customer instances.',
    required: false,
  },
  insights_laneperformance: {
    groupName: 'Insights',
    icon: 'IconChartArcs3',
    title: 'Lane Performance',
    description:
      'Lane-level performance analytics with carrier, waypoint, compliance, and sustainability drill-downs.',
    required: false,
  },
}

/**
 * @param {string} key
 */
export function getFeatureCatalogLeafMetadata(key) {
  const k = String(key || '').trim()
  if (!k) return null
  return FEATURE_CATALOG_LEAF_METADATA[k] || null
}

/**
 * @param {string} key
 */
export function buildSyntheticFeatureCatalogGroup(key) {
  const meta = getFeatureCatalogLeafMetadata(key)
  if (meta) {
    return {
      name: meta.groupName,
      icon: meta.icon,
      features: [
        {
          key,
          title: meta.title,
          description: meta.description,
          required: meta.required ?? false,
        },
      ],
    }
  }
  return {
    name: key,
    icon: 'IconSettings',
    features: [{ key, title: key, description: '', required: false }],
  }
}
